import React, { useMemo, useState } from 'react';
import styles from '../EditNetSuiteWarehouseForm/EditNetSuiteWarehouseForm.module.scss';
import SimpleInput from '../../common/SimpleInput';
import Button from '../../common/Button';
import { useDispatch, useSelector } from 'react-redux';
import { updateWarehouseData } from '../../../store/actions/warehouses';
import _ from 'lodash';
import { InfoTooltip } from '../../common/InfoTooltip';
import history from '../../../utils/history';

export function EditCin7Form({ warehouse }) {
  const dispatch = useDispatch();
  const submitting = useSelector((state) => state.warehouses.submitting);

  const {
    orders_integration_data: { connection_data: ordersConnectionData },
    inventory_integration_data: { locations, connection_data: inventoryConnectionData },
  } = warehouse;

  const [form, setForm] = useState({
    userEmail: ordersConnectionData.user || inventoryConnectionData.user || '',
    apiKey: ordersConnectionData.api_key || inventoryConnectionData.api_key || '',
    locations: locations.join(',') || '',
  });

  const onChange = (e) => {
    setForm((prevForm) => ({
      ...prevForm,
      [e.target.name]: e.target.value,
    }));
  };

  const isDisabled = useMemo(() => submitting, [submitting]);

  const backToWarehousesPage = (e) => {
    history.push(`/suppliers/${warehouse.supplier_id}/admin/warehouses`);
  };

  const onSubmit = (e) => {
    const data = {
      orders_integration_data: _.merge({}, warehouse.orders_integration_data, {
        connection_data: {
          user: form.userEmail,
          api_key: form.apiKey,
        },
      }),
      inventory_integration_data: _.merge({}, warehouse.inventory_integration_data, {
        connection_data: {
          user: form.userEmail,
          api_key: form.apiKey,
        },
        locations: form.locations.split(',').map(Number),
      }),
      returns_integration_data: _.merge({}, warehouse.returns_integration_data, {
        connection_data: {
          user: form.userEmail,
          api_key: form.apiKey,
        },
      }),
    };

    dispatch(updateWarehouseData(warehouse.id, data));

    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div className={styles.wrapper}>
      <h2>Warehouse: {warehouse.name}</h2>

      <form className={styles.form} onSubmit={onSubmit}>
        <div className={styles.body}>
          <div className={styles.formControl}>
            <label>
              User Email:
              <span className={styles.mandatory}>*</span>
            </label>
            <SimpleInput value={form.userEmail} onChange={onChange} name="userEmail" type="email" />
          </div>

          <div className={styles.formControl}>
            <label>
              API key:
              <span className={styles.mandatory}>*</span>
              <InfoTooltip width={250} content={<p>Please obtain from your Cin7 account</p>} />
            </label>
            <SimpleInput value={form.apiKey} onChange={onChange} focus={false} name="apiKey" />
          </div>

          <div className={styles.formControl}>
            <label>
              Locations:
              <span className={styles.mandatory}>*</span>
              <InfoTooltip
                width={300}
                content={
                  <p>
                    Please indicate the Cin7 location IDs from which to pull inventory (eg. <strong>123, 456</strong>)
                  </p>
                }
              />
            </label>
            <SimpleInput value={form.locations} onChange={onChange} focus={false} name="locations" />
          </div>
        </div>

        <div className={styles.footer}>
          <Button type="button" text="Cancel" disabled={submitting} onClick={backToWarehousesPage} color="white" />
          <Button type="submit" text="Save" loading={submitting} disabled={isDisabled} />
        </div>
      </form>
    </div>
  );
}
